// extracted by mini-css-extract-plugin
module.exports = {"sidebarSpacer":"CompetitionMain_sidebarSpacer__jPqUp"};